import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CustomerService } from '../../../services/customer.service';
import { AddCustProductLookupComponent } from '../add-cust-product-lookup/add-cust-product-lookup.component';
import { gridPageRequest } from '../../../model/common/common.model';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import _ from 'lodash';

@Component({
  selector: 'app-customer-product-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './customer-product-lookup.component.html',
  styleUrl: './customer-product-lookup.component.scss'
})
export class CustomerProductLookupComponent implements OnInit {
  @ViewChild('dt1') dt1: Table | undefined;
  constructor(private customerService: CustomerService, public dialogService: DialogService, private config: DynamicDialogConfig,
    public ref: DynamicDialogRef, private messageService: MessageService, private confirmationService: ConfirmationService) { }

  loader: boolean = false;
  list: any[] = [];
  selected: any[] = [];
  searchKey: string | undefined;
  // ref: DynamicDialogRef = new DynamicDialogRef;
  customerCode: string | undefined;
  customerId: number = 0;

  pageRequest: gridPageRequest = {
    pageIndex: 1,
    pageSize: 20,
    id: 0
  }

  ngOnInit(): void {
    this.customerCode = this.config.data?.CustomerCode;
    this.customerId = this.config.data?.CustomerId;
    this.getCustomerProduct();
  }

  getCustomerProduct() {
    this.loader = true;
    this.customerService.getCustomerProductList(this.pageRequest, this.customerId).subscribe({
      next: (data: any) => {
        this.loader = false;
        this.list = data.customerProductList;

      },
      error: (error: any) => {
        this.loader = false;
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'An error occurred while retrieving Customer Product.' });
      }
    });
  }

  search() { }

  refreshData() {
    if (this.dt1) {
      this.dt1.first = 0;
      this.dt1.clear();
    }
    this.searchKey = '';
    this.pageRequest.pageSize = 20;
    this.getCustomerProduct();
    this.selected = [];
  }

  load(event: any): void {
    if (this.searchKey && this.searchKey.trim() !== '') {
      return;
    } else {
      this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
      this.getCustomerProduct();
    }
  }

  addCustomerProduct() {
    this.ref = this.dialogService.open(AddCustProductLookupComponent, {
      header: `Add Cust Product Code for ${this.customerCode}`,
      width: '80%',
      data: { CustomerCode: this.customerCode, CustomerId: this.customerId }
    });
    this.ref.onClose.subscribe((data: string) => {
      if (data) {
        this.refreshData();
      }
    });
  }

  delete() {
    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: 'Please confirm to proceed.',
      accept: () => {
        this.loader = true;

        var customerProductId = _.map(this.selected, 'customerProductId');

        this.customerService.deleteCustomerProduct(customerProductId).subscribe({
          next: (data: any) => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted successfully.' });
            this.loader = false;
            this.selected = [];
            this.refreshData();
          },
          error: error => {
            this.loader = false;
            console.log(error);
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error occured while delete.' });
          }
        })
      },
      reject: () => {
      }
    });
  }

}
